<!-- eslint-disable max-lines -->
<template>
    <paper v-loading="btnloading" class="responsible-flow" >
        <div class="top-box-resp">
            <!-- 按钮区域 -->
            <div class="detail-toolBar-resp">
                <lots-button type="primary"
                    v-if="showBtn.editBtn"
                     @click="handleEdit">编辑
                </lots-button>
                <lots-button type="primary"
                    v-if="showBtn.saveBtn"
                    :loading="saveLoading" @click="handleSave">保存
                </lots-button>
                <lots-button type="primary"
                    v-if="showBtn.createFlowBtn"
                    :disabled="['2','3'].includes(detailDataLocal.execStatus+'')"
                    :loading="flowLoading" @click="handleFlow">提交审批
                </lots-button>
                <el-tooltip class="item-flow-right" effect="dark" content="刷新" placement="bottom">
                    <lots-button size="mini" icon="el-icon-refresh" class="refresh" @click="refleshPage()"
                        :loading="detailLoading">
                    </lots-button>
                </el-tooltip>
            </div>
        </div>
        <div class="resp-hr"></div>
        <div class="responsible-detail" v-loading="detailLoading">
            <!-- 表单区域 -->
            <collapse-infos ref="upholdHealder" :detailData="detailDataLocal" :collapse="COLLAPSE"
                :activeCollapses="activeCollapses" @change="handleInfosChange">
                <!-- 折叠筐标题插槽 -->
                <template v-slot:collapse-title-append="{ collapseItem }">
                    <span>{{ collapseItem.title }}</span>
                </template>
                <!-- 表单字段插槽 -->
                <template v-slot:collapse-append="{ form, itemSetting, rIndex, collapseItem, dictData }">
                    <span v-if="itemSetting.prop === 'respDataManageFiles'">
                        <lots-upload-button :text="'上传附件'" :bucket="'annto-lcrm'"
                            :disabled="['3', '4', '7'].includes(detailDataLocal.approvalStatus + '') || !isHandleEdit"
                            @callback="(data) => { upLoadData(form, itemSetting, data); }">
                        </lots-upload-button>
                        <div class="file-infos">
                            <template v-if="form[itemSetting.prop]
                                && form[itemSetting.prop].length">
                                <div class="file-list" v-for="(item, index) in form[itemSetting.prop]"
                                    :key="index + item.fileName">
                                    <div class="file-name upload" :title="item.fileName">
                                        {{ `${index + 1}. ` }}
                                        <a :href="item.fileUrl" target="_blank">{{ item.fileName }}</a>
                                    </div>
                                    <div class="delete-btn">
                                        <el-button type="text" plain @click="handlePreview(item)">
                                            预览
                                        </el-button>
                                        <el-button type="text" plain>
                                            <a :href="item.fileUrl" target="_blank">下载</a>
                                        </el-button>
                                        <el-button type="text"
                                            :disabled="['2','3', '4'].includes(detailDataLocal.approvalStatus + '')|| !isHandleEdit" plain
                                            @click="handleDeleteFile(form, itemSetting, index)">删除</el-button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </span>
                    <span v-else-if="itemSetting.prop ==='importDataFiles'" class="custom-span file-infos">
                        <div class="file-list" >
                            <div class="file-name upload delete-btn" >
                                <lots-upload-button v-if="showBtn.importBtn && !form[itemSetting.prop].fileName" :text="'导入文件'" :bucket="'annto-lcrm'"
                                    :disabled="!showBtn.importBtnDisabled"
                                    @callback="(data) => { upLoadData(form, itemSetting, data); }">
                                </lots-upload-button>
                                <span v-else>
                                    <a class="import-file-text" :href="form['importDataFiles'].fileUrl" target="_blank">{{ form[itemSetting.prop].fileName }}</a>
                                    <el-button type="text" v-if="form[itemSetting.prop].fileName" class="delete-file-btn"
                                        :disabled="['2', '3', '4'].includes(detailDataLocal.approvalStatus + '') || !isHandleEdit || ['2','3'].includes(detailDataLocal.execStatus+'')" plain
                                        @click="handleDeleteFile(form, itemSetting)">删除</el-button>
                                </span>
                                <lots-button type="text" class="down-mould-btn" v-if="showBtn.downBtn"
                                    :loading="downLoading" @click="handleDownloadMould">下载模板</lots-button>
                            </div>
                        </div>
                    </span>
                    <span v-else-if="['remark'].includes(itemSetting.prop)" class="resp-remark-wrap">
                        <span :title="(form[itemSetting.prop]) || '--'" class="resp-remark-wrap" v-html="(form[itemSetting.prop]) ? form[itemSetting.prop] : '--'"
                            ></span>
                        <!-- <el-input
                            type="textarea"
                            :rows="5"
                            :readonly="true"
                            placeholder="--"
                            v-model="form[itemSetting.prop]">
                        </el-input> -->
                    </span>
                    <span v-else-if="['dataType'].includes(itemSetting.prop)" class="custom-span">
                        {{ (form[itemSetting.prop] || form[itemSetting.prop] === 0) ? codesToNames(form[itemSetting.prop],dictDatas['SYNC_BIG_DATA_TYPE']) : '--' }}
                    </span>
                    <span v-else-if="!itemSetting.optionsKey" class="custom-span" :title="form[itemSetting.prop]">
                        {{ (form[itemSetting.prop] || form[itemSetting.prop] === 0) ? form[itemSetting.prop] : '--' }}
                    </span>

                </template>
            </collapse-infos>

            <!-- iflow区域 -->
            <el-collapse v-if="detailDataLocal.mipId" class="contract-collapse detail-more-collapse" value="mipInfo">
                <el-collapse-item title="流程信息" name="mipInfo">
                    <div class="header-operation">
                        <lots-button size="mini" type="primary" v-if="!['7'].includes(detailDataLocal.approvalStatus + '')"
                            @click="submitMip" :loading="btnloading">
                            mip提交
                        </lots-button>
                    </div>
                    <iframe class="ifr" :src="mipUrl" v-if="!btnloading" />
                </el-collapse-item>
            </el-collapse>
        </div>

    </paper>
</template>

<script>
import { ref, computed, getCurrentInstance, onMounted, onActivated } from '@vue/composition-api';
import paper from '@/components/core/Paper.vue';
import lotsButton from '@/components/lots/lotsButton';
import CollapseInfos from '@/modules/mdm/views/contractModules/components/collapseInfos/CollapseInfos.vue';
import lotsUploadButton from '@/components/lots/oss/UploadBtn';
import { respTemplateDownloadApi, respTemplateDeleteDownloadApi, getResponsibleDetail, saveResponsibleDetail,
    sumbitResponsibleFlow, checkImportResponsible } from '@mdm/api/contractManage/customerPersonResponsibleDataApi.js';
import { getNodesAndOperationApi } from '@mdm/utils/flowUtils.js';
import { approveProcess } from '@/modules/mdm/api/contractManage/detailMainApi.js';
import { Message, MessageBox } from 'element-ui';
import store from '@/store/index';
import utils from '@/components/utils/common.js';
import { collapse } from './collapseInfosConfig.js';
import _ from 'lodash';
import configurl from '@/config/user.env';
import { filePreview } from '@/utils/filePreview.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
const { MAGIC_NUMBER } = utils;
export default {
    name: 'responsibleFlow',
    components: {
        paper,
        lotsButton,
        CollapseInfos,
        lotsUploadButton
    },
    props: { },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        const config = _.cloneDeep(collapse);
        const detailLoading = ref(false);
        const btnloading = ref(false);
        const detailDataLocal = ref({
            mipId: '',
            respDataManageFiles: [], // 相关附件
            importDataFiles: { } // 导入附件
        });

        // * 1：草稿；
        // * 2：待审批；
        // * 3：审批中；
        // * 4：审批通过；
        // * 5：审批驳回；
        // * 6：撤回；
        // * 7：作废

        // const authority = store.getters.authority;
        // eslint-disable-next-line max-len
        const activeCollapses = ref(['basicInfo']);
        const mipUrl = ref('');
        const COLLAPSE = computed(() => { // 配置项动态计算
            const { approvalStatus, operationType, dataType } = detailDataLocal.value;
            config.forEach((v, i) => {
                // eslint-disable-next-line complexity
                v.formList.forEach((v2, i2) => {
                    const fieldsEdit = showBtn.value.isMipStatus ? false : isHandleEdit.value;
                    if (['remark', 'billTitle'].includes(v2.prop)) {
                        v2.type = fieldsEdit ? 'input' : 'custom'; // 审批中、审批通过、废弃
                    }
                    if ([ 'operationType', 'dataType' ].includes(v2.prop)) {
                        v2.type = fieldsEdit ? 'select' : 'custom'; // 审批中、审批通过、
                    }
                    if ([ 'dataMonth' ].includes(v2.prop)) {
                        v2.type = fieldsEdit ? 'time' : 'custom'; // 审批中、审批通过、
                    }
                    if ([ 'importDataFiles' ].includes(v2.prop)) {
                        v2.rule[0].required = ['2', '3', '4'].includes(operationType?.toString()) && ['3', '4', '6', '7', '9', '10'].includes(dataType);
                    }
                    if (['dataType'].includes(v2.prop)) {
                        const _dataTypeOptions = _.cloneDeep(dictDatas.value['SYNC_BIG_DATA_TYPE']);
                        const _options = _.pick(_dataTypeOptions, operationTypeDataTypeRelation[operationType]);
                        v2.options = _options;
                        v2.disabled = !Object.keys(_options).length;
                    }
                });
            });
            return config;
        });
        const showBtn = computed(() => {
            const { approvalStatus, operationType, dataType, dataMonth } = detailDataLocal.value;
            const isMipStatus = ['2', '3', '4'].includes(approvalStatus?.toString());
            return {
                isMipStatus,
                // editBtn: isMipStatus || mipCreateUserCode !== userCode ? false : !isHandleEdit.value,
                editBtn: isMipStatus ? false : !isHandleEdit.value,
                saveBtn: isMipStatus ? false : isHandleEdit.value,
                downBtn: !isMipStatus && ['3', '4', '6', '7', '9', '10'].includes(dataType) && ['2', '4'].includes(operationType?.toString()),
                // importBtn: isMipStatus ? false : isHandleEdit.value && ['2', '3', '4'].includes(operationType?.toString()),
                importBtn: !isMipStatus,
                importBtnDisabled: isHandleEdit.value && ['2', '4'].includes(operationType?.toString())
                && ['3', '4', '6', '7', '9', '10'].includes(dataType?.toString()) && dataMonth,
                createFlowBtn: isMipStatus ? false : ['2', '4'].includes(operationType?.toString())
            };
        });

        const newMip = ref(false);
        const refleshPage = () => {
            if (isHandleEdit.value) {
                MessageBox.confirm(`你当可能存在编辑未保存的数据，刷新页面将覆盖编辑的数据，确认继续刷新？`, `注意：`, {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _initData();
                });
            } else {
                _initData();
            }
        };
        // 处理详情返回数据格式
        const formatData = (data) => {
            const newData = _.cloneDeep(data);
            !newData.respDataManageFiles && (newData.respDataManageFiles = []);
            return newData;
        };
        const { userName, userCode } = store.getters.user;
        // eslint-disable-next-line complexity
        const _initData = async () => {
            const { id } = ctx.$route.query;
            detailLoading.value = true;
            if (id) {
                try {
                    await getResponsibleInfo();
                } catch (error) {
                    // detailLoading.value = false;
                }
            }
            detailLoading.value = false;
            handleInfosChange({ form: formatData(detailDataLocal.value) });
        };
        const currentAuth = ref(false);
        const isHandleEdit = ref(false);
        // eslint-disable-next-line complexity
        const handleInfosChange = async (formObjData = {}) => { // 表单组件编辑回调，更新本地数据
            const { itemSetting, targetForm } = formObjData;
            // 监控表单是否编辑过
            if (!itemSetting) { // 页面初始化、刷新时走：
                if (detailDataLocal.value.mipId) {
                    handleCreate(); // 渲染iflow流程
                    currentAuth.value = await getNodesAndOperationApi({ fdId: detailDataLocal.value.mipId, loginName: userCode });
                }
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
            } else { // collapse组件编辑回调时走：
                const { respDataManageFiles } = detailDataLocal.value;
                if (itemSetting.prop === 'operationType') {
                    if (!['2', '3', '4'].includes(targetForm[itemSetting.prop])) {
                        targetForm['importDataFiles'] = {};
                    }
                    targetForm['dataType'] = '';
                }
                if (itemSetting.prop === 'dataType' && !['3', '4', '6', '7', '9', '10'].includes(targetForm[itemSetting.prop])) {
                    targetForm['importDataFiles'] = {};
                }
                // 除了插槽参数以外，其他参数取最新编辑的参数更新(因：插槽的编辑不会触发collapse组件change事件回调，因此change事件回调的插槽的参数是旧数据不能取)
                detailDataLocal.value = Object.assign(
                    {},
                    detailDataLocal.value,
                    formObjData.form,
                    targetForm,
                    { respDataManageFiles } // 保证插槽数据用最新的
                );
            }
        };

        const handleCreate = () => {
            mipUrl.value = '';
            mipUrl.value = `${configurl.iflowUrl}?fdId=${detailDataLocal.value.mipId}&fdTemplateKey=CRM_resp_data_manage&userCode=${userCode}&userName=${userName}`;
            createMetaNode();
            window.addEventListener('message', messageFunc, false);
            newMip.value && setTimeout(() => {
                const element = document.getElementsByClassName('responsible-flow')[0];
                element.scrollTo(0, MAGIC_NUMBER.TWO_THOUSAND); // 页面滚动到MIP审批位置
                newMip.value = false;
            }, MAGIC_NUMBER.FOUR_HUNDRED);
        };
        const createMetaNode = () => {
            const mipmeta = document.getElementById('mipmeta');
            if (mipmeta) {
                return false;
            }
            const meta = document.createElement('meta');
            meta.httpEquiv = 'Content-Security-Policy';
            meta.content = 'upgrade-insecure-requests';
            meta.id = 'mipmeta';
            document.getElementsByTagName('head')[0].appendChild(meta);
        };
        const timer = 1800;
        // approveProcess 回调提取为独立函数，减少嵌套
        const handleApproveProcess = (params) => {
            return approveProcess(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('提交成功');
                    const times = setTimeout(async () => {
                        getResponsibleInfo();
                        currentAuth.value = await getNodesAndOperationApi({ fdId: detailDataLocal.value.mipId, loginName: userCode });
                        clearTimeout(times);
                    }, timer);
                } else {
                    Message.error(res.msg);
                }
            }).finally(() => {
                btnloading.value = false;
            });
        };
        // 参数准备辅助函数
        const prepareApproveParams = (eventData) => {
            const { id, mipId } = detailDataLocal.value;
            const { origin, pathname } = window.location;
            const params = eventData.data || {};
            const { tenantCode } = store.getters.currentTenant;
            params.tenantCode = tenantCode;
            params.currentApplicationCode = 'APP201904230047';
            if (params.formParam) {
                const { processParam } = params;
                let isToOtherPersons = '';
                if (processParam.operationType === 'circulate' && processParam.toOtherPersons) {
                    isToOtherPersons = processParam.toOtherPersons;
                }
                // eslint-disable-next-line max-len
                params.formParam.fdUrl = `${origin}${pathname}#/responsibleFlow?id=${id}&fdId=${mipId}${isToOtherPersons ? `&isToOtherPersons=${isToOtherPersons}` : ''}`;
            }
            return params;
        };
        // draft_submit分支处理
        const handleDraftSubmit = async (params) => {
            try {
                const saveRes = await handleSave(true);
                if (saveRes && +saveRes.code === 0) {
                    await handleApproveProcess(params);
                } else {
                    btnloading.value = false;
                }
            } catch (e) {
                btnloading.value = false;
            }
        };
        // 主流程调度
        const messageFunc = async (event) => {
            if (currentTime.value !== store.getters.iflowPage.pageTime) return;
            if (!(event.data && event.data.data && event.data.success)) return;
            btnloading.value = true;
            const params = prepareApproveParams(event.data);
            const processParam = params.processParam || {};
            if (processParam.operationType === 'draft_submit' && isHandleEdit.value) {
                const data = checkSubmit();
                if (!data) {
                    btnloading.value = false;
                    return;
                }
                await handleDraftSubmit(params);
                handleApproveProcess(params);
                return;
            }
            handleApproveProcess(params);
        };
        // eslint-disable-next-line complexity
        const submitMip = async () => {
            const content = window;
            content.frames && content.frames.length && content.frames[0]
                && content.frames[0].postMessage('mbpm_getApprovalData', mipUrl.value);
            content.frames && content.frames.length && content.frames[1]
                && content.frames[1].postMessage('mbpm_getApprovalData', mipUrl.value); // 解决接入了智能客服后，content.frames[0]被占用了的问题
            currentTime.value = new Date().getTime();
            store.commit('updateIflowPage', { pageTime: currentTime.value });
        };
        const currentTime = ref('');
        const saveLoading = ref(false);
        // 校验操作类型与数据类型的依赖关系
        const operationTypeDataTypeRelation = {
            '1': ['2', '3', '4', '5', '6', '7', '8', '10'], // 系统跑数
            '2': ['3', '4', '6', '7', '9', '10'], // 偏差调整
            // '3': ['11'], // 数据导入
            // '4': ['3', '4', '6', '7', '9', '10', '11'] // 删除
            '4': ['3', '4', '6', '7', '9', '10'] // 删除
        };
        const checkSubmit = () => {
            const data = _.cloneDeep(setupContext.refs.upholdHealder.onsave());
            // const data = setupContext.refs.upholdHealder.localizeData;
            if (!data) return false;

            const { respDataManageFiles, operationType, dataType } = detailDataLocal.value;

            const allowedDataTypes = operationTypeDataTypeRelation[operationType];
            if (allowedDataTypes && !allowedDataTypes.includes(dataType)) {
                const dataTypeLabel = dictDatas.value['SYNC_BIG_DATA_TYPE']?.[dataType] || '未知类型';
                const allowedLabels = allowedDataTypes.map(type => dictDatas.value['SYNC_BIG_DATA_TYPE']?.[type] || type).join('、');
                Message.warning(`当前操作类型"${dictDatas.value['LCRM_INC_OPERATION_TYPE']?.[operationType]}"与数据类型"${dataTypeLabel}"不匹配。允许的数据类型：${allowedLabels}`);
                return false;
            }
            const params = { ...data, respDataManageFiles };
            if ([2, 3, 4].includes(+params.approvalStatus)) {
                Message.warning('流程为待审批/审批中/审批通过时，不允许修改！');
                return false;
            }

            return data;
        };
        const handleSave = (mipSubmit = false) => {
            const data = checkSubmit();
            if (!data) {
                return { };
            };
            const { respDataManageFiles, importDataFiles } = detailDataLocal.value;
            const params = _.cloneDeep({ ...data, respDataManageFiles });
            if (importDataFiles.fileUrl) {
                params.respDataManageFiles.push(importDataFiles);
            }
            delete params.importDataFiles;
            if (mipSubmit !== true) {
                saveLoading.value = true;
            }
            return saveResponsibleDetail(params).then(res => {
                if (+res.code === 0 && res.data) {
                    newMip.value = true;
                    isHandleEdit.value = false;
                    if (mipSubmit === true) return res; // 排除点击事件的event
                    Message.success('保存成功');
                    // 更新地址栏url参数
                    const { origin, pathname } = window.location;
                    window.location.assign(`${origin}${pathname}#/responsibleFlow?id=${detailDataLocal.value.id}`);
                    refleshPage();
                }
            }).finally(() => { saveLoading.value = false; });
        };
        const handleEdit = () => {
            isHandleEdit.value = true;
        };
        const flowLoading = ref(false);
        const handleFlow = async () => {
            if (isHandleEdit.value) {
                const saveRes = await handleSave(true);
                if (saveRes && +saveRes.code === 0) {
                    submitFlowhandle();
                }
                return;
            }
            submitFlowhandle();
        };
        const submitFlowhandle = () => {
            const params = {
                billId: detailDataLocal.value.id
            };
            flowLoading.value = true;
            sumbitResponsibleFlow(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('提交审批成功');
                    _initData();
                }
                flowLoading.value = false;
            }).finally(() => {
                flowLoading.value = false;
            });
        };
        const downLoading = ref(false);

        const handleDownloadMould = () => {
            const { dataType, operationType } = detailDataLocal.value;
            const _name = dictDatas.value['SYNC_BIG_DATA_TYPE']?.[dataType] || '责任制';
            let params = {
                fileName: _name + '导入模版.xlsx',
                dataType: dataType
            };
            downLoading.value = true;
            let downApi = respTemplateDownloadApi;
            if (operationType?.toString() === '4') {
                params = { fileName: '责任制数据导入删除模板.xlsx' };
                downApi = respTemplateDeleteDownloadApi;
            }
            downApi(params).then(res => {
                try {
                    return JSON.parse(res); // 是 JSON 对象
                } catch (e) {
                    Message.success('下载成功');
                }
                downLoading.value = false;
            }).finally(() => {
                downLoading.value = false;
            });
        };
        // eslint-disable-next-line complexity
        const upLoadData = async (form, itemSetting, data) => {
            const { prop } = itemSetting;
            // form[prop] = form[prop] ? form[prop] : [];
            if (data && +data.code === 0) {
                const formRefs = setupContext.refs.upholdHealder.$refs.dcForm;
                if (prop === 'respDataManageFiles') {
                    form[prop].push({ fileName: data.data.name, fileUrl: data.data.downUrl, fileType: '1' });
                } else if (prop === 'importDataFiles') {
                    try {
                        const res = await checkImportResponsible({
                            dataType: detailDataLocal.value.dataType,
                            periodMonth: detailDataLocal.value.dataMonth,
                            operationType: detailDataLocal.value.operationType,
                            fileUrl: data.data.downUrl
                        });
                        // eslint-disable-next-line max-depth
                        if (res && +res.code === 0) {
                            form[prop] = { fileName: data.data.name, fileUrl: data.data.downUrl, fileType: '0' };
                        }
                    } catch (error) {
                        //
                    }
                }
                const targetRef = formRefs.find(item => item._props.refName === 'basicForm');
                targetRef.$refs['basicForm'].validateField(prop);
                detailDataLocal.value = Object.assign({}, detailDataLocal.value, form);
            }
        };
        const handleDeleteFile = (form, itemSetting, index) => {
            const { prop } = itemSetting;
            const formRefs = setupContext.refs.upholdHealder.$refs.dcForm;
            if (prop === 'respDataManageFiles') {
                form[prop].splice(index, 1);
            } else if (prop === 'importDataFiles') {
                form[prop] = {};
            }
            detailDataLocal.value = Object.assign({}, detailDataLocal.value, form);
            const targetRef = formRefs.find(item => item._props.refName === 'basicForm');
            targetRef.$refs['basicForm'].validateField(prop);
        };

        const getResponsibleInfo = () => {
            const id = ctx.$route.query.id || detailDataLocal.value.id;
            if (!id) return;
            isHandleEdit.value = false;
            btnloading.value = true;
            return getResponsibleDetail({
                id
            }).then(res => {
                if (res && +res.code === 0) {
                    detailDataLocal.value = res.data;
                    detailDataLocal.value.dataType = res.data.dataType?.toString();
                    detailDataLocal.value.importDataFiles = res.data.respDataManageFiles?.find(it => it.fileType?.toString() === '0') || {};
                    detailDataLocal.value.respDataManageFiles = res.data.respDataManageFiles?.filter(it => it.fileType?.toString() === '1') || [];
                    detailDataLocal.value = Object.assign(detailDataLocal.value, _.pick(res.data.flowInfo, ['mipId']));
                    setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value); // 刷新表单子组件
                }
            }).finally(() => {
                btnloading.value = false;
            });
        };
        const handlePreview = (row) => {
            filePreview({
                fileUrl: row.fileUrl,
                fileName: row.fileName
            });
        };
        const dictDatas = ref({});
        onMounted(async () => {
            dictDatas.value = await otherUtils.getDictDataList([], ['LCRM_INC_OPERATION_TYPE', 'SYNC_BIG_DATA_TYPE']);
        });
        onActivated(() => {
            const id = ctx.$route.query.id;
            if (id === detailDataLocal.value.id) return;
            detailDataLocal.value = { };
            setupContext.root.$nextTick(() => {
                _initData();
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate(); // 重置校验报错
            });
        });
        return {
            config,
            COLLAPSE,
            detailLoading,
            btnloading,
            detailDataLocal,
            mipUrl,
            activeCollapses,
            saveLoading,
            showBtn,
            flowLoading,
            downLoading,
            isHandleEdit,
            dictDatas,
            codesToNames: otherUtils.codesToNames,
            refleshPage,
            handleInfosChange,
            submitMip,
            handleSave,
            upLoadData,
            handleDeleteFile,
            handlePreview,
            handleDownloadMould,
            handleFlow,
            handleEdit
        };
    }
};
</script>
<style lang="less" scoped>

.responsible-flow {
    // overflow: auto;
    display: flex;
    flex-direction: column;

    .top-box-resp {
        .header-box {
            width: 100%;

            h4 {
                text-align: center;
                font-size: 20px;
                margin: 0;
                color: #606266;
            }

            .header-info-crm {
                width: 100%;
                display: flex;
                font-size: 14px;
                border-bottom: 1px solid #dde0e6;
                margin-bottom: 10px;
                padding-bottom: 5px;

                .tips {
                    flex: 1;
                    // color: red;
                    color: #606266;
                    line-height: 20px;
                }

                .apply-info {
                    width: 200px;
                    line-height: 20px;
                    color: #606266;
                    margin-left: 10px;
                }
            }
        }

        .detail-toolBar-resp {
            .item-flow-right {
                float: right;

                &.refresh {
                    margin-left: 10px;
                }
            }
        }
    }
    .resp-hr{
        border-bottom: 1px solid #EBEEF5;
        margin: 10px 0 5px 0;
    }
    .responsible-detail {
        overflow: auto;

        .upload-demo {
            display: inline-block;
        }

        .down-mould-btn {
            margin-left: 5px;
        }

        .upload-tips {
            display: inline-block;
            margin-left: 10px;
            line-height: 28px;
            font-size: 12px;
            color: #606266;
        }

        .file-infos {
            width: 100%;
            padding: 0 10px 0 0;

            .file-list {
                width: 100%;
                padding: 2px 0 2px 0px;
                display: flex;

                // justify-content: space-between;
                .file-name {

                    // flex: 1;
                    &.upload {
                        width: 500px;
                    }

                    padding-right: 5px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: inline-block;
                }

                .view-btn,
                .delete-btn {
                    width: 200px;
                    display: flex;

                    a {
                        color: #4285F5;
                    }

                    .el-button:focus,
                    .el-button:hover,
                    .el-button:active,
                    .el-button.is-disabled {
                        outline: none !important;
                        border-color: transparent !important;
                        /* 可选：如果要去除激活时的边框颜色变化 */
                    }
                }
                .delete-file-btn{
                    margin-left: 10px;
                }
                .import-file-text{
                    color: #0000ee!important;
                }
                a{
                    text-decoration: none;
                }
            }
        }

        .el-collapse-item__content {
            padding-bottom: 5px;
        }

        .el-collapse-item__arrow {
            margin: 0 8px 0 5px;
        }

        .el-button.is-disabled.is-plain,
        .el-button.is-disabled.is-plain:focus,
        .el-button.is-disabled.is-plain:hover {
            border-color: #FFF;
        }
        .resp-remark-wrap{
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp:10; /* 限制行数 */
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: pre-wrap; /* 保留空格和换行 */
            word-break: break-all; /* 允许单词内换行 */
        }

        .width-small {
            width: 340px;
        }

        .width-middle {
            width: 500px;
        }

        .width-large {
            width: 1200px;
        }

        .el-col.el-col-23.form-item {
            .el-form-item.el-form-item--mini {
                margin-bottom: 18px;
            }
        }

        .el-collapse-item__header {
            height: 32px;
        }

        .detail-form-collapse {
            padding-right: 10px;
        }

        .score-config-item-box {
            .item-tittle {
                font-size: 14px;
                font-weight: 600;
                color: #606266;
                margin-left: 28px;
            }
        }
        .rating-score-list-box {
            .el-collapse {
                border-bottom: none;

                .el-collapse-item__header {
                    border-bottom: none;
                }

                .el-collapse-item__wrap {
                    border-bottom: none;
                }
            }
        }
    }

    .ifr {
        width: 100%;
        height: 100vh;
        border: none;
    }

    .el-collapse-item__header {
        color: #606266;
        font-size: 14px;
        font-weight: 600;
    }

    .header-operation {
        margin-top: 10px;
    }

    .resistr-add {
        float: right;
        margin-bottom: 8px;
        margin-right: 8px;
    }
}

.no-auth-reg {
    font-size: 16px;
    padding: 20px;
    background: #fff;
    width: 100%;
}

.my-tooltip-box {
    width: 800px;
}
</style>
